'use strict';

var withStyles = require('../../Styles/withStyles.js');
var CardActions$1 = require('../../../node_modules/@material-ui/core/esm/CardActions/CardActions.js');

var styles = function styles() {
  return {
    root: {
      padding: '8px 12px 16px 12px'
    }
  };
};
var CardActions = withStyles["default"](styles)(CardActions$1["default"]);

module.exports = CardActions;
